import { __, sprintf } from '@wordpress/i18n';
import SbUtils from '../../../Utils/SbUtils'
import GridLayout from './GridLayout'
import CarouselLayout from './CarouselLayout';
import MasonryLayout from './MasonryLayout';
import ListLayout from './ListLayout';
import GalleryLayout from './GalleryLayout';

const PostsWrapper = ({ feedSettings, headerData, posts, isPro, isFeedEditor, feedId, editorActiveDevice = 'desktop' }) => {
    const layoutProps = {
        headerData,
        posts,
        feedSettings,
        editorActiveDevice,
        isPro,
        isFeedEditor,
        feedId,
    }

    const postsLoopOutput = () => {
        switch (feedSettings.layout) {
            case 'grid':
                return (
                    <GridLayout
                        {...layoutProps}
                    />
                )
            case 'list':
                return (
                    <ListLayout
                        {...layoutProps}
                    />
                )
            case 'masonry':
                return (
                    <MasonryLayout
                        {...layoutProps}
                    />
                )
            case 'carousel':
                return (
                    <CarouselLayout
                        {...layoutProps}
                    />
                )
            case 'gallery':
                return (
                    <GalleryLayout
                        {...layoutProps}
                    />
                )
            default:
                return (
                    <GridLayout
                        {...layoutProps}
                    />
                )
        }
    }

    // SMASH-1382 v3-frontend (T7): give the feed an accessible region name so
    // SR users get a labeled landmark to navigate to (the posts are otherwise
    // an unlabeled pile of buttons). Item-level list/listitem semantics are
    // tracked separately (per-layout, to avoid axe "list" direct-child issues).
    const feedUsername = headerData?.[0]?.username || headerData?.username;
    const feedLabel = feedUsername
        ? sprintf(/* translators: %s: TikTok account username */ __('TikTok feed from @%s', 'sb-customizer'), feedUsername)
        : __('TikTok feed', 'sb-customizer');

    return (
        <section
            className='sb-feed-posts sb-fs'
            data-avatar-size='medium'
            aria-label={feedLabel}
        >
            {posts.length > 0 && postsLoopOutput()}
            {isFeedEditor && SbUtils.addHighlighter('posts-layout', 'Posts Layout', 0, true)}
        </section>
    )
}
export default PostsWrapper;